export default __webpack_public_path__ + "static/media/Print_certificate2025_April.11302e17.jpg";